'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import FichaPaginaMobile from './Designs/Mobile';
import FichaPaginaDesktop from './Designs/Desktop';
import useFichaPaginaHook, {
  useFichaPaginaHookType,
} from './hook/useFichaPaginaHook';
import { Fragment, useEffect, useRef } from 'react';
import ModalAdicionarPlaylist from '@/components/organisms/ModalAdicionarPlaylist';
import FichaPaginaFallback from './fallback';
import { useHomeData } from '@/hooks/useHomeData';
import { ConteudoRecomendacao } from '@/services/types/recomendacao';
import { registrarEvento } from '@/services/googleAnalytics';
import { UniversalScrollTracker } from '@/components/organisms/UniversalScrollTracker';
import ModalSelecionarPlataforma from '@/components/organisms/ModalSelecionarPlataforma';

export type FichaPaginaRouteProps = {
  $slug: string;
};

export type FichaPaginaProps = useFichaPaginaHookType & {
  emAltaStreaming: ConteudoRecomendacao[] | null;
  carregandoEmAltaStreaming: boolean;
};

export default function FichaPagina(props: FichaPaginaRouteProps) {
  const { breakpoint } = useBreakpoint();
  const { $slug } = props;
  const renderizou = useRef<boolean>(false);

  const propsFichaPagina = useFichaPaginaHook($slug);
  const {
    recuperarPlataformas,
    mostrandoModalPlaylists,
    fecharModalPlaylists,
    ficha,
    loadingFicha,
    fichaID,
    loadingPlataformas,
    plataformas,
    plataformaSelecionada,
    setPlataformaSelecionada,
    mostrandoModalPlataformas,
    setMostrandoModalPlataformas,
    enviarComentario,
  } = propsFichaPagina;

  const {
    emAltaStreaming,
    carregandoEmAltaStreaming,
    recuperarEmAltaStreaming,
    recuperarListasUsuario,
    recuperarTiposDenunciaResenha,
    tiposDenunciaResenha,
  } = useHomeData();

  useEffect(() => {
    recuperarPlataformas();
    recuperarListasUsuario({});

    if (tiposDenunciaResenha == null || tiposDenunciaResenha.length === 0) {
      recuperarTiposDenunciaResenha();
    }

    if (
      (emAltaStreaming == null || emAltaStreaming.length === 0) &&
      !carregandoEmAltaStreaming
    ) {
      recuperarEmAltaStreaming();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (renderizou.current === false && ficha != null) {
      renderizou.current = true;
      registrarEvento('visualizar_ficha', {
        fichaID: ficha?.tituloID,
        ficha: ficha?.titulo,
      });
    }
  }, [ficha]);

  if (loadingFicha || ficha == null) {
    return <FichaPaginaFallback />;
  }

  return (
    <Fragment>
      <UniversalScrollTracker pagina="ficha" debug={false} />
      {breakpoint === 'mobile' ? (
        <FichaPaginaMobile
          {...propsFichaPagina}
          emAltaStreaming={emAltaStreaming}
          carregandoEmAltaStreaming={carregandoEmAltaStreaming}
        />
      ) : (
        <FichaPaginaDesktop
          {...propsFichaPagina}
          emAltaStreaming={emAltaStreaming}
          carregandoEmAltaStreaming={carregandoEmAltaStreaming}
        />
      )}
      <ModalAdicionarPlaylist
        $visivel={mostrandoModalPlaylists}
        $fichaID={fichaID}
        $cancelarBotaoFuncao={fecharModalPlaylists}
      />
      <ModalSelecionarPlataforma
        $loading={loadingPlataformas}
        modalVisivel={mostrandoModalPlataformas}
        controlarVisibilidade={setMostrandoModalPlataformas}
        $plataformas={plataformas || []}
        $plataformaSelecionada={plataformaSelecionada}
        $funcaoSelecionarPlataforma={setPlataformaSelecionada}
        funcaoEnviar={enviarComentario}
      />
    </Fragment>
  );
}
